// extracted by mini-css-extract-plugin
export default {"orderBtn":"OrderPreparedTable_orderBtn__HuCR4","themeColor":"OrderPreparedTable_themeColor__onKB7"};